import React from 'react'
import Month from './month';
import styles from './base-calendar.module.scss';
import { ViewCommonProps, Year as YearProps } from '../../../../../../components/shared/calendar/types';

interface YearRendererProps extends ViewCommonProps {
    year?: YearProps;
    showHeader?: boolean;
    columns?: number;
}

export default function Year(props: YearRendererProps) {
    const { year, activeDate, showHeader, columns = 1 } = props;
    const renderMonths = () => {
        return Array.from({ length: 12 }, (_, i) => i).map((m) => {
            const monthDate = activeDate.clone().set('month', m).startOf('day');
            const month = year?.months.find(x => x.id === monthDate.month() + 1);
            return (<Month
                month={month}
                key={monthDate.unix()}
                showHeader={showHeader}
                {...props} activeDate={monthDate} 
                fullFlex/>)
        })
    }

    return (
        <div
            className={styles.monthsGrid}
            style={{ gridTemplateColumns: `repeat(${columns}, auto)` }}
        >
            {renderMonths()}
        </div>
    )
}
